import UpdateBar from '@/pages/home/components/UpdateBar';
import Masthead from '@/pages/home/components/Masthead';
import IntroStrip from '@/pages/home/components/IntroStrip';
import FlashFeed from '@/pages/home/components/FlashFeed';
import MelonRanking from '@/pages/home/components/MelonRanking';
import InfluencerSection from '@/pages/home/components/InfluencerSection';
import StarSection from '@/pages/home/components/StarSection';
import CommentZone from '@/pages/home/components/CommentZone';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <UpdateBar />
      <Masthead />
      <main>
        <IntroStrip />
        <FlashFeed />
        <MelonRanking />
        <InfluencerSection />
        <StarSection />
        <CommentZone />
      </main>
      <SiteFooter />
    </div>
  );
}